import { useState, useEffect } from 'react';
import { Form, Row, Col, Container, Card, CardBody } from 'reactstrap';
import { useSelector } from 'react-redux';
import TextField from '../../../common/TextField';
import { RootState } from '../../../../ReduxToolkit/Store';
import MobileField from '../../../common/MobileField';

export default function CRMProfile() {
    const [profileFormData, setProfileFormData] = useState({
        firstName: '',
        surname: '',
        email: '',
        mobile: ''
    });
    const userData = useSelector((state: RootState) => state.adminAuth);
    useEffect(() => {
        if (userData) {
            setProfileFormData({
                firstName: userData.FirstName || '',
                surname: userData.LastName || '',
                email: userData.email || '',
                mobile: userData.ContactNo || ''
            });
        }
    }, [userData]);

    const handleProfileValueChange = (name: string, value: string) => {
        setProfileFormData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    };

    const renderProfileForm = () => (
        <Form>
            <Row>
                <TextField
                    label="First Name"
                    type="text"
                    name="firstName"
                    value={profileFormData.firstName}
                    setValue={handleProfileValueChange}
                    placeholder="First Name"
                    passCol="col-8"
                    design="flex"
                    maxChars={20}
                />
                <TextField
                    label="Surname"
                    type="text"
                    name="surname"
                    value={profileFormData.surname}
                    setValue={handleProfileValueChange}
                    placeholder="Surname"
                    passCol="col-8"
                    design="flex"
                    maxChars={20}
                />
                <TextField
                    label="Email"
                    type="email"
                    name="email"
                    value={profileFormData.email}
                    setValue={handleProfileValueChange}
                    placeholder="Email"
                    passCol="col-8"
                    design="flex"
                    maxChars={50}
                />
                <MobileField
                    label="Mobile"
                    mobileField="mobile"
                    value={profileFormData.mobile}
                    setValue={handleProfileValueChange}
                    placeholder="Mobile"
                    design="flex"
                    passCol="col-8"
                    maxLength={18}
                />
            </Row>
        </Form>
    );

    return (
        <Container fluid className="d-flex align-items-center justify-content-center" style={{ height: '60vh' }}>
            <Row
                className="d-flex shadow-sm rounded p-4 bg-white"
                style={{
                    width: '100%',
                    maxWidth: '1200px',
                    height: '300px',
                }}
            >
                <Col xs={12} className="d-flex flex-column flex-grow-1 p-4">
                    <Card>
                        <CardBody>
                            {renderProfileForm()}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}
